module.exports = __webpack_public_path__ + "img/609.7ab0b5cd.jpg";